export class PmConfig{
    
    allowMultipleProductByBarcode? : boolean;
    stepQuantities? : string[];
    showBoxQuantityToSteps? : boolean;
    
    filterByBrand? : boolean;
    filterByCategory? : boolean;
    filterByLocation? : boolean;

    showProductImages? : boolean;

    constructor(){
        this.allowMultipleProductByBarcode = false;
        this.stepQuantities = ['1','10'];
        this.showBoxQuantityToSteps = true;
        this.filterByCategory = true;
        this.showProductImages = true;
    }
}
